import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setModal } from '../../../../../../data/actions'

const AddUserSection = ({ dispatchModal }) => (
  <wb-tooltip-host position="top">
    <button
      href="#"
      className="wb-button wb-button--primary wb-button--small"
      onClick={() => {
        dispatchModal({
          variant: 'addUser',
          header: 'Add new User(s) to your Tenant',
          onCancel: () => {
            dispatchModal({})
          },
        })
      }}
    >
      <wb-icon
        class="wb-button__icon "
        style={{ marginRight: '12px' }}
        aria-hidden="true"
        flip-rtl
        name="bds/plus/24"
      ></wb-icon>
      Add User
      <wb-tooltip>
        User needs to login to TDMS once and complete profile
      </wb-tooltip>
    </button>
  </wb-tooltip-host>
)

AddUserSection.propTypes = {
  dispatchModal: PropTypes.func,
}

export const TenantMembersAddUserSection = connect(null, {
  dispatchModal: setModal,
})(AddUserSection)
